<template>
  <b-modal
    ref="migrateResellersModal"
    centered
    size="lg"
    title="Migrate resellers to another tariff"
    hide-header-close
    scrollable
    footer-bg-variant=""
    @hidden="clearMigrationTargetTariff()">

    <b-form-group
      id="tariffsDropdown"
      label="Migrate to"
      label-for="recipe-input">
      <b-form-select
        :value="migrationTargetTariff"
        :disabled="activeTariffsEmpty"
        @change="saveMigrationTargetTariff($event)">
        <template #first>
          <b-form-select-option
            :value="DEFAULT_SELECTED_TARIFF"
            disabled>
            Select tariff to migrate to
          </b-form-select-option>
        </template>
        <b-form-select-option
          v-for="tariff in excludedActiveTariffs(selectedTariffId)"
          :key="`tariff-${tariff._id}`"
          :value="tariff">
          {{ tariff.name }}
        </b-form-select-option>
      </b-form-select>
    </b-form-group>

    <b-row>
      <b-col
        cols="12"
        lg="5">
        <div class="font-weight-bold mb-2">Current Tariff</div>
        <b-list-group class="mb-0">
          <b-list-group-item class="d-flex align-items-center">
            Name
            <span class="ml-auto">{{ selectedTariff.name }}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex align-items-center">
            Code
            <span class="ml-auto">{{ selectedTariff.code }}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex align-items-center">
            Resellers
            <b-badge
              variant="light"
              class="ml-auto"
              pill>{{ selectedTariff.total_referrals }}</b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-col>

      <b-col
        cols="12"
        lg="2"
        class=" d-none d-lg-flex justify-content-center align-items-center">
        <i class="fas fa-arrow-right fa-lg"></i>
      </b-col>

      <b-col
        cols="12"
        lg="5">
        <div class="font-weight-bold mb-2 mt-6 mt-lg-0">Target Tariff</div>
        <template v-if="migrationTargetTariffEmpty">
          <b-card
            hide-header
            border-variant="light"
            align="center"
            body-class="p-0">
            <no-data-found :text="'Please select tariff'" />
          </b-card>
        </template>
        <template v-else>
          <b-list-group class="mb-0">
            <b-list-group-item class="d-flex align-items-center">
              Name
              <span class="ml-auto">{{ migrationTargetTariff.name }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex align-items-center">
              Code
              <span class="ml-auto">{{ migrationTargetTariff.code }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex align-items-center">
              Resellers
              <b-badge
                variant="light"
                class="ml-auto"
                pill>{{ migrationTargetTariff.total_referrals }}</b-badge>
            </b-list-group-item>
          </b-list-group>
        </template>
      </b-col>
    </b-row>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('migrateResellersModal')">
          Cancel
        </b-button>
        <b-button
          variant="primary"
          size="md"
          class="ml-auto"
          :disabled="
            activeTariffsEmpty || migrationTargetTariffEmpty || tariffsResponses('migrateTariffResellers')
          "
          @click="
            migrateTariffResellers(),
            hideModal('migrateResellersModal')
          ">
          <span>Migrate Resellers</span>
          <span
            v-if="!migrationTargetTariffEmpty"
            class="ml-1">
            ({{ selectedTariff.total_referrals }})
          </span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  // actions
  MIGRATE_TARIFF_RESELLERS,

  // mutations
  SAVE_MIGRATION_TARGET_TARIFF,
  CLEAR_MIGRATION_TARGET_TARIFF,

  // constants
  DEFAULT_SELECTED_TARIFF
} from '@/core/services/store/tariffs.module'
import { showModal, hideModal } from '@/core/utils'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
  name: 'ModalMigrateResellers',
  data() {
    return {
      DEFAULT_SELECTED_TARIFF: DEFAULT_SELECTED_TARIFF,
      
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'activeTariffs',
      'activeTariffsEmpty',
      'excludedActiveTariffs',
      'selectedTariff',
      'selectedTariffId',
      'migrationTargetTariff',
      'migrationTargetTariffEmpty',
      'tariffsResponses'
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    migrateTariffResellers() {
      this.$store.dispatch(MIGRATE_TARIFF_RESELLERS, {
        currTariff: this.selectedTariff,
        targetTariff: this.migrationTargetTariff
      })
    },

    saveMigrationTargetTariff(tariff) {
      this.$store.commit(SAVE_MIGRATION_TARGET_TARIFF, tariff)
    },

    clearMigrationTargetTariff() {
      this.$store.commit(CLEAR_MIGRATION_TARGET_TARIFF)
    },
  }
}
</script>
